import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzGruas } from '@/mocks/localSeoData';

export default function RecuperacaoGruasFlorestaisAracruz() {
  return <LocalSeoPage data={aracruzGruas} />;
}